import React from "react";
import { buttonClass } from "../styles/buttonShell";

function Button({
    variant = "primary",
    size = "md",
    disabled = false,
    type = "button",
    className = "",
    children,
    ...rest
}) {
    return (
        <button
            type={type}
            className={buttonClass(variant, size, className)}
            disabled={disabled}
            {...rest}
        >
            {children}
        </button>
    );
}

export default Button;
